// Almacenamiento aislado de la sesión por PIN.
//
// La sesión PIN vive SOLO en localStorage con el prefijo `cables-pin:` y nunca
// toca la cookie SSO de .vlscr.net: si la tocara, un PIN en una tablet
// compartida iniciaría sesión (o cerraría la de alguien) en todos los módulos.
// El marcador `cables-modo-pin` decide a qué almacén va supabase-js, y se lee
// en CADA llamada para que el modo cambie en caliente sin recrear el cliente.
import cookieStorage from './cookieStorage';

export const MODO_KEY = 'cables-modo-pin';
export const PIN_PREFIX = 'cables-pin:';
const META_KEY = `${PIN_PREFIX}meta`;

const seguro = (fn, porDefecto = null) => {
  try {
    return fn();
  } catch (e) {
    return porDefecto;
  }
};

export const modoPin = () => seguro(() => localStorage.getItem(MODO_KEY) !== null, false);

export const activarModoPin = () => {
  seguro(() => localStorage.setItem(MODO_KEY, '1'));
};

export const desactivarModoPin = () => {
  seguro(() => {
    const claves = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PIN_PREFIX)) claves.push(k);
    }
    claves.forEach((k) => localStorage.removeItem(k));
  });
  seguro(() => localStorage.removeItem(MODO_KEY));
};

export const pinStorage = {
  getItem: (key) => seguro(() => localStorage.getItem(PIN_PREFIX + key)),
  setItem: (key, value) => {
    seguro(() => localStorage.setItem(PIN_PREFIX + key, value));
  },
  removeItem: (key) => {
    seguro(() => localStorage.removeItem(PIN_PREFIX + key));
  },
};

const actual = () => (modoPin() ? pinStorage : cookieStorage);

export const storageDinamico = {
  getItem: (key) => actual().getItem(key),
  setItem: (key, value) => actual().setItem(key, value),
  removeItem: (key) => actual().removeItem(key),
};

// ¿Queda una sesión de auth (la clave sb-*-auth-token de supabase-js) en el
// almacén PIN? Sirve para distinguir "sin red, todavía recuperable" de "no hay
// nada que recuperar".
export const haySesionPinGuardada = () =>
  seguro(() => {
    for (let i = 0; i < localStorage.length; i += 1) {
      const k = localStorage.key(i);
      if (k && k.startsWith(PIN_PREFIX) && /^sb-.+-auth-token$/.test(k.slice(PIN_PREFIX.length))) return true;
    }
    return false;
  }, false);

export const guardarMeta = ({ nombre, colaboradorId, expiraEl, sesionId = null }) => {
  seguro(() => localStorage.setItem(META_KEY, JSON.stringify({ nombre, colaboradorId, expiraEl, sesionId })));
};

export const leerMeta = () =>
  seguro(() => {
    const raw = localStorage.getItem(META_KEY);
    if (!raw) return null;
    const m = JSON.parse(raw);
    return m && typeof m === 'object' ? m : null;
  });

export const borrarMeta = () => {
  seguro(() => localStorage.removeItem(META_KEY));
};
